import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig
} from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './_guards/auth.guard';
import { AuthService } from './_services/auth.service';

// Routing
import { routing } from './app.routing';
// Components
import { AppComponent } from './app.component';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { LoginComponent } from './login';
import { NavbarService } from './_services/navbar.service';
// perfect scroll bar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { DeviceDetectorService } from './_services/device-detector.service';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from './_layout/breadcrumb/breadcrumb.module';
import { BlockTemplateComponent } from './_layout/blockui/block-template.component';
import { BlockUIModule } from 'ng-block-ui';
import { MatchHeightModule } from './content/partials/general/match-height/match-height.module';
import { ToastrModule } from 'ngx-toastr';
import { PrivacyPolicyComponent } from './login/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './login/terms-condition/terms-condition.component';
import { PortalComponent } from './_layout/portal-egresado/portal/portal.component';
import { PortalEmpresaComponent } from './_layout/portal-empresa/portal-empresa/portal-empresa.component';
import { PortalDocenteComponent } from './_layout/portal-docente/portal-docente/portal-docente.component';
import { ContactoComponent } from './_layout/contacto/contacto/contacto.component';
import { PublicHeaderComponent } from './_layout/public-header/public-header/public-header.component';
import { PublicFooterComponent } from './_layout/public-footer/public-footer/public-footer.component';
import { LoginEgresadoComponent } from './login/egresado/egresado.component';
import { LoginAdministradorComponent } from './login/administrador/administrador.component';
import { LoginDocenteComponent } from './login/docente/docente.component';
import { EmpresaRegistroComponent } from './register/empresa-registro/empresa-registro.component';
import { EgresadoHeaderComponent } from './_layout/egresado/egresado-header/egresado-header.component';
import { EgresadoNavComponent } from './_layout/egresado/egresado-nav/egresado-nav.component';
import { AdminHeaderComponent } from './_layout/admin/admin-header/admin-header.component';
import { AdminNavComponent } from './_layout/admin/admin-nav/admin-nav.component';
import { EmpresaNavComponent } from './_layout/empresa/empresa-nav/empresa-nav.component';
import { EmpresaHeaderComponent } from './_layout/empresa/empresa-header/empresa-header.component';
import { DocenteHeaderComponent } from './_layout/docente/docente-header/docente-header.component';
import { DocenteNavComponent } from './_layout/docente/docente-nav/docente-nav.component';
import { AdminModule } from './content/admin/admin.module';
import { DocenteModule } from './content/docente/docente.module';
import { LoginEmpresaComponent } from './login/empresa/empresa.component';
import { JwtInterceptor } from './_helpers/jwt-interceptor';
import { PrivateLayoutEgresadoComponent } from './_layout/egresado/private-layout-egresado/private-layout-egresado.component';
import { SharedComponentsModule } from './shared-components/shared-components.module';
import { NgModule } from '@angular/core';
import { LottieModule } from 'ngx-lottie';
import { PrivateLayoutEmpresaComponent } from './_layout/empresa/private-layout-empresa/private-layout-empresa.component';
import { EgPerfilComponent } from './content/egresado/eg-perfil/eg-perfil.component';
import { SettingsEmpresaModule } from './_layout/settings/settingsEmpresa.module';
import { ThemeSettingsEmpresaConfig } from './_layout/settings/EmpresaSettings/theme-empresa-settings.config';
import { MenuEmpresaSettingsConfig } from './_layout/settings/EmpresaSettings/menu-empresa-settings.config';
import { PrivateLayoutDocenteComponent } from './_layout/docente/private-layout-docente/private-layout-docente.component';
import { PrivateLayoutAdminComponent } from './_layout/admin/private-layout-admin/private-layout-admin.component';
import { SettingsDocenteModule } from './_layout/settings/settingsDocente.module';
import { ThemeSettingsDocenteConfig } from './_layout/settings/DocenteSettings/theme-docente-settings.config';
import { MenuDocenteSettingsConfig } from './_layout/settings/DocenteSettings/menu-docente-settings.config';
import { SettingsEgresadoModule } from './_layout/settings/settingsEgresado.module';
import { MenuEgresadoSettingsConfig } from './_layout/settings/EgresadoSettings/menu-egresado-settings.config';
import { ThemeSettingsEgresadoConfig } from './_layout/settings/EgresadoSettings/theme-egresado-settings.config';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import lottie from 'lottie-web';
import { ErrorModule } from './content/full-pages/error/error.module';
import { ThemeSettingsAdminConfig } from './_layout/settings/AdminSettings/theme-admin-settings.config';
import { SettingsAdminModule } from './_layout/settings/settingsAdmin.module';
import { MenuAdminSettingsConfig } from './_layout/settings/AdminSettings/menu-admin-settings.config';
import { DocPasswordComponent } from './content/docente/doc-password/doc-password.component';
import { SettingsPublicoModule } from './_layout/settings/settingsPublico.module';
import { ThemeSettingsPublicoConfig } from './_layout/settings/PublicSettings/theme-publico-settings.config';
import { MenuPublicoSettingsConfig } from './_layout/settings/PublicSettings/menu-publico-settings.config';
import { PublicNavComponent } from './_layout/public-nav/public-nav.component';
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return lottie;
}

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatchHeightModule,
    BreadcrumbModule,
    NgbModule,
    FormsModule,
    AdminModule,
    DocenteModule,
    ErrorModule,
    SharedComponentsModule,
    LottieModule.forRoot({ player: playerFactory }),
    routing,
    SettingsEgresadoModule.forRoot(ThemeSettingsEgresadoConfig,MenuEgresadoSettingsConfig),
    SettingsEmpresaModule.forRoot(ThemeSettingsEmpresaConfig,MenuEmpresaSettingsConfig),
    SettingsDocenteModule.forRoot(ThemeSettingsDocenteConfig,MenuDocenteSettingsConfig),
    SettingsAdminModule.forRoot(ThemeSettingsAdminConfig,MenuAdminSettingsConfig),
    SettingsPublicoModule.forRoot(ThemeSettingsPublicoConfig,MenuPublicoSettingsConfig),
    PerfectScrollbarModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxSpinnerModule,
    // LottieModule,
    // LoadingBarRouterModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient]
      }
    }),
    RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module
  ],
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    // AlertComponent,
    // SocialSigninComponent,
    LoginComponent,
    BlockTemplateComponent,
    PrivacyPolicyComponent,
    TermsConditionComponent,
    PortalComponent,
    PortalEmpresaComponent,
    PortalDocenteComponent,
    ContactoComponent,
    PublicHeaderComponent,
    PublicFooterComponent,
    LoginEgresadoComponent,
    LoginAdministradorComponent,
    LoginDocenteComponent,
    LoginEmpresaComponent,
    EmpresaRegistroComponent,
    EgresadoHeaderComponent,
    EgresadoNavComponent,
    AdminHeaderComponent,
    AdminNavComponent,
    EmpresaNavComponent,
    EmpresaHeaderComponent,
    DocenteHeaderComponent,
    DocenteNavComponent,
    PrivateLayoutEgresadoComponent,
    PrivateLayoutEmpresaComponent,
    EgPerfilComponent,
    DocPasswordComponent,
    PrivateLayoutDocenteComponent,
    PrivateLayoutAdminComponent,
    PublicNavComponent
  ],
  providers: [
    AuthGuard,
    // ChartApiService,
    // AlertService,
    NavbarService,
    // TableApiService,
    DeviceDetectorService,
    AuthService,
    // UserService,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig
    },
    // NgbCarouselConfig,
    // NgbModalConfig,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: "6LcvpJslAAAAAJRkpMT8-r2ofNiuHs5HF7gdjtsC" }
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule]
})
export class AppModule { }
